export interface StatisticItem {
    id: string;
    title: string;
    location: string;
    type: 'range' | 'location';
    data: RangeData[] | LocationData[];
    total: string;
    year: string;
}

export interface RangeData {
    month: string;
    MonthlyRange: string;
    AverageMonth: number;
}

export interface LocationData {
    location: string;
    MonthlyRange: string;
}

const StatisticData: StatisticItem[] = [
    {
        id: "1",
        title: "Хөвсгөл аймаг машины зорчих статистик",
        location: "Хөвсгөл аймаг",
        type: "range",
        year: "2024",
        total: "204,875",
        data: [
            { month: "1-р сар", MonthlyRange: "450", AverageMonth: 13950 },
            { month: "2-р сар", MonthlyRange: "450", AverageMonth: 13050 },
            { month: "3-р сар", MonthlyRange: "475", AverageMonth: 14775 },
            { month: "4-р сар", MonthlyRange: "525", AverageMonth: 15750 },
            { month: "5-р сар", MonthlyRange: "550", AverageMonth: 17050 },
            { month: "6-р сар", MonthlyRange: "550", AverageMonth: 16500 },
            { month: "7-р сар", MonthlyRange: "800", AverageMonth: 24000 },
            { month: "8-р сар", MonthlyRange: "600", AverageMonth: 18000 },
            { month: "9-р сар", MonthlyRange: "550", AverageMonth: 17050 },
            { month: "10-р сар", MonthlyRange: "500", AverageMonth: 15000 },
            { month: "11-р сар", MonthlyRange: "450", AverageMonth: 13050 },
            { month: "12-р сар", MonthlyRange: "450", AverageMonth: 13050 }
        ]
    },
    {
        id: "2",
        title: "Эрдэнэт хот машины зорчих статистик",
        location: "Эрдэнэт хот",
        type: "range",
        year: "2024",
        total: "205,325",
        data: [
            { month: "1-р сар", MonthlyRange: "350–400", AverageMonth: 11625 },
            { month: "2-р сар", MonthlyRange: "350–400", AverageMonth: 11625 },
            { month: "3-р сар", MonthlyRange: "400–450", AverageMonth: 13375 },
            { month: "4-р сар", MonthlyRange: "450–500", AverageMonth: 14250 },
            { month: "5-р сар", MonthlyRange: "600–650", AverageMonth: 19375 },
            { month: "6-р сар", MonthlyRange: "700–750", AverageMonth: 21750 },
            { month: "7-р сар", MonthlyRange: "750–800", AverageMonth: 26035 },
            { month: "8-р сар", MonthlyRange: "600–650", AverageMonth: 18750 },
            { month: "9-р сар", MonthlyRange: "500–550", AverageMonth: 16275 },
            { month: "10-р сар", MonthlyRange: "400–450", AverageMonth: 12750 },
            { month: "11-р сар", MonthlyRange: "350–400", AverageMonth: 11625 },
            { month: "12-р сар", MonthlyRange: "350–400", AverageMonth: 11625 }
        ]
    },
    {
        id: "3",
        title: "Архангай аймаг машины зорчих статистик",
        location: "Архангай аймаг",
        type: "location",
        year: "2024",
        total: "98,550",
        data: [
            { location: "Зундаа", MonthlyRange: "350–450" },
            { location: "Өвөлдөө", MonthlyRange: "130–180" },
            { location: "Жилийн дундаж", MonthlyRange: "270" }
        ]
    },
    {
        id: "4",
        title: "Булган аймаг машины зорчих статистик",
        location: "Булган аймаг",
        type: "location",
        year: "2024",
        total: "109,500",
        data: [
            { location: "Зундаа", MonthlyRange: "400–500" },
            { location: "Өвөлдөө", MonthlyRange: "150–200" },
            { location: "Жилийн дундаж", MonthlyRange: "300" }
        ]
    },
    {
        id: "5",
        title: "Завхан аймаг машины зорчих статистик",
        location: "Завхан аймаг",
        type: "location",
        year: "2024",
        total: "73,000",
        data: [
            { location: "Зундаа", MonthlyRange: "250-350" },
            { location: "Өвөлдөө", MonthlyRange: "100-140" },
            { location: "Жилийн дундаж", MonthlyRange: "200" }
        ]
    }
];

export default StatisticData;